import {
  OpcoesRepositorioBaseComFiltragemDeLeitura,
  RepositorioBaseComFiltragemDeLeitura,
} from "@/http"
import { AxiosPromise } from "axios"
import { ParamsAtributo, AtributoBase } from "./atributos.modelos"
import { ResultadoApiGET } from "@/types/api"
import { TiposCapacidadesPossiveis } from "@/types/capacidades"
import { TiposCaracteristicaPossiveis } from "@/types/caracteristicas"

class AtributosRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public constructor(
    opcoesRepositorio: OpcoesRepositorioBaseComFiltragemDeLeitura = {}
  ) {
    super({
      ...opcoesRepositorio,
      parametrosPadrao: {
        "ordenar-por": ["asc.nome"],
      },
    })
  }

  public criarNovoAtributo = (body: AtributoBase): AxiosPromise<AtributoBase> =>
    this.instance.post("/api/atributos", body)
  public listarTodosAtributosCapacidades = <T = string>(
    params: ParamsAtributo<"igual.capacidade">
  ): Promise<ResultadoApiGET<AtributoBase<T, TiposCapacidadesPossiveis>>> =>
    this.instance.get("/api/atributos", { params })
  public listarTodosAtributosCaracteristicas = <T = string>(
    params: ParamsAtributo<"igual.caracteristica">
  ): Promise<ResultadoApiGET<AtributoBase<T, TiposCaracteristicaPossiveis>>> =>
    this.instance.get("/api/atributos", { params })
  public listarAtributos = (
    params: ParamsAtributo
  ): Promise<ResultadoApiGET<AtributoBase>> =>
    this.instance.get("/api/atributos", { params })
  public buscarAtributoPorId = (
    id: string
  ): Promise<ResultadoApiGET<AtributoBase>> =>
    this.instance.get("/api/atributos", { params: { id } })
}

export default AtributosRepositorio
